// extracted by mini-css-extract-plugin
export default {"root":"ActivityStatus_root__S1z6M","active":"ActivityStatus_active__gsoo0","inactive":"ActivityStatus_inactive__XkOfM"};